import ProductService from "@/api/services/ProductService";
import CategoryService from "@/api/services/CategoryService";
import OrderService from "@/api/services/OrderService";
import AccountService from "@/api/services/AccountService";
import CartService from "@/api/services/CartService";
import PaymentService from "@/api/services/PaymentService";
import PlatformService from "@/api/services/PlatformService";
import MarketingService from "./services/MarketingService";

export default class Api {

  private static _payment: PaymentService = PaymentService.of();

  static get payment(): PaymentService {
    return Api._payment;
  }

  private static _platform: PlatformService = PlatformService.of();

  static get platform(): PlatformService {
    return Api._platform;
  }

  private static _category: CategoryService = CategoryService.of();

  static get category(): CategoryService {
    return Api._category;
  }

  private static _cart: CartService = CartService.of();

  static get cart(): CartService {
    return Api._cart;
  }

  private static _order: OrderService = OrderService.of();

  static get order(): OrderService {
    return Api._order;
  }

  private static _product: ProductService = ProductService.of();

  static get product(): ProductService {
    return Api._product;
  }

  private static _account: AccountService = AccountService.of();

  static get account(): AccountService {
    return Api._account;
  }

  private static _marketing: MarketingService = MarketingService.of();

  static get marketing(): MarketingService {
    return Api._marketing;
  }
}